import { render, staticRenderFns } from "./ExecutorsInNorthernIreland.vue?vue&type=template&id=1716e4f7"
import script from "./ExecutorsInNorthernIreland.vue?vue&type=script&lang=js"
export * from "./ExecutorsInNorthernIreland.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports